import React from "react";
import clsx from "clsx";
import Modal, { ModalProps } from "react-bootstrap/Modal";

const ModalWrapper: React.FC<
  ModalProps & {
    id?: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    title?: React.ReactNode;
    className?: string;
    titleIcon?: React.ReactNode;
    stickyCloseButton?: boolean;
    showHeader?: boolean;
    bgColorSecondary?: boolean;
    fullHeight?: boolean;
    preventOtherActions?: boolean;
    "data-testid"?: string;
    hideCloseButton?: boolean;
    stackingModal?: boolean;
  }
> = ({
  id,
  children,
  footer,
  show = true,
  title,
  onHide = () => {},
  className = "",
  size,
  backdrop,
  titleIcon,
  stickyCloseButton,
  showHeader = true,
  bgColorSecondary = false,
  centered = false,
  fullHeight = false,
  preventOtherActions = false,
  "data-testid": dataTestId,
  hideCloseButton = false,
  stackingModal = false,
  ...otherProps
}) => {
  const modalBackdrop = preventOtherActions ? "static" : backdrop;
  const classNames = clsx(className, {
    "modal--sticky-close-btn": stickyCloseButton,
    "modal--bg-color-secondary": bgColorSecondary,
    "modal--full-height": fullHeight,
    "modal--prevent-other-actions": preventOtherActions,
    "modal--stacking": stackingModal
  });

  return (
    <Modal
      id={id}
      backdrop={modalBackdrop}
      show={show}
      onHide={onHide}
      className={classNames}
      size={size}
      autoFocus={false}
      centered={centered || fullHeight}
      data-testid={dataTestId}
      backdropClassName={clsx({
        "static-backdrop": preventOtherActions,
        "modal-backdrop--stacking": stackingModal
      })}
      {...otherProps}
    >
      {(!showHeader || stickyCloseButton) && (
        <div
          className={`modal__close-btn-container ${
            stickyCloseButton ? "modal__close-btn-container--sticky" : ""
          }`}
        >
          <button className="btn-close" onClick={onHide} />
        </div>
      )}
      {showHeader && (
        <Modal.Header closeButton={!stickyCloseButton && !hideCloseButton}>
          <Modal.Title
            as="h2"
            data-testid={dataTestId ? `${dataTestId}_title` : null}
          >
            {titleIcon && (
              <span className="modal-title__icon-container">{titleIcon}</span>
            )}
            {title}
          </Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body data-testid={dataTestId ? `${dataTestId}_content` : null}>
        {children}
      </Modal.Body>
      {footer && (
        <Modal.Footer data-testid={dataTestId ? `${dataTestId}_footer` : null}>
          {footer}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ModalWrapper;
